interface AnalyticsPluginRestProxyTrackArgs {
  event: object;
  topic: string;
  topic_schema_id: string;
}

// Payload sent to sentEvent of RestProxy
// this is a better name as not all usages of this service are through the analytics plugin
type RestProxyPayload = AnalyticsPluginRestProxyTrackArgs;

interface BaseEvent {
  anonymous_id?: string;
  context_library_name: string;
  git_commit_id: string;
  event_text: string;
  user_uid?: string;
  uuid: string;
}

const EXPERIMENT_TRIGGERS_INTAKE_TOPIC = "experiment_triggers_raw";
const EXPERIMENT_TRIGGERS_INTAKE_TOPIC_SCHEMA_ID = "100298";
const EXPERIMENT_TRIGGERS_REFINED_TOPIC = "experiment_triggers";
const EXPERIMENT_TRIGGERS_REFINED_TOPIC_SCHEMA = "experiment_triggers-value";

const EXPERIMENT_ASSIGNMENTS_INTAKE_TOPIC = "experiment_assignments_raw";
const EXPERIMENT_ASSIGNMENTS_INTAKE_TOPIC_SCHEMA_ID = "100187";
const EXPERIMENT_ASSIGNMENTS_REFINED_TOPIC = "experiment_assignments";
const EXPERIMENT_ASSIGNMENTS_REFINED_TOPIC_SCHEMA =
  "experiment_assignments-value";

const LEARNER_TRACKING_INTAKE_TOPIC = "tracking_events_raw";
const LEARNER_TRACKING_INTAKE_TOPIC_SCHEMA_ID = "100586";
const LEARNER_TRACKING_REFINED_TOPIC = "tracking_events";
const LEARNER_TRACKING_REFINED_TOPIC_SCHEMA = "tracking_events-value";

const SEARCH_IMPRESSIONS_INTAKE_TOPIC = "search_impressions_raw";
const SEARCH_IMPRESSIONS_INTAKE_TOPIC_SCHEMA_ID = "100201";
const SEARCH_IMPRESSIONS_REFINED_TOPIC = "search_impressions";
const SEARCH_IMPRESSIONS_REFINED_TOPIC_SCHEMA = "search_impressions-value";

// for generic events and data
const ANALYTICS_EVENTS_TOPIC = "analytics_events";
const ANALYTICS_EVENTS_SCHEMA_ID = "100558";

const TRUSTOS_EVENTS_TOPIC = "trustos_events";
const TRUSTOS_EVENTS_SCHEMA_ID = "100612";

export {
  BaseEvent,
  AnalyticsPluginRestProxyTrackArgs,
  RestProxyPayload,
  EXPERIMENT_TRIGGERS_INTAKE_TOPIC,
  EXPERIMENT_TRIGGERS_INTAKE_TOPIC_SCHEMA_ID,
  EXPERIMENT_TRIGGERS_REFINED_TOPIC,
  EXPERIMENT_TRIGGERS_REFINED_TOPIC_SCHEMA,
  EXPERIMENT_ASSIGNMENTS_INTAKE_TOPIC,
  EXPERIMENT_ASSIGNMENTS_INTAKE_TOPIC_SCHEMA_ID,
  EXPERIMENT_ASSIGNMENTS_REFINED_TOPIC,
  EXPERIMENT_ASSIGNMENTS_REFINED_TOPIC_SCHEMA,
  ANALYTICS_EVENTS_TOPIC,
  ANALYTICS_EVENTS_SCHEMA_ID,
  LEARNER_TRACKING_INTAKE_TOPIC,
  LEARNER_TRACKING_REFINED_TOPIC,
  LEARNER_TRACKING_INTAKE_TOPIC_SCHEMA_ID,
  LEARNER_TRACKING_REFINED_TOPIC_SCHEMA,
  SEARCH_IMPRESSIONS_INTAKE_TOPIC,
  SEARCH_IMPRESSIONS_INTAKE_TOPIC_SCHEMA_ID,
  SEARCH_IMPRESSIONS_REFINED_TOPIC,
  SEARCH_IMPRESSIONS_REFINED_TOPIC_SCHEMA,
  TRUSTOS_EVENTS_TOPIC,
  TRUSTOS_EVENTS_SCHEMA_ID,
};
